module.exports = __webpack_public_path__ + "static/media/welcome_bonus-compact.755da868.svg";